export default "__VITE_ASSET__332ae2c9__"